import { ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NapFormProvider } from "./NapFormContext";
import { UseFormReturn } from "react-hook-form";
import { NapFormData } from "./NapFormContext";

// Steps for the Nap form
export const NAP_STEPS = [
  'start',
  'end', 
  'location',
  'environment',
  'onset',
  'sleep_latency',
  'restfulness',
  'sleep_debt',
  'notes'
] as const;

export type NapStepType = typeof NAP_STEPS[number];

interface NapStepContainerProps {
  form: UseFormReturn<NapFormData>;
  currentStep: NapStepType;
  onNext: () => void;
  onPrev: () => void;
  children: ReactNode;
}

/**
 * Container component for nap form steps with animation transitions
 * Provides form context and handles step navigation animation
 */
export function NapStepContainer({ 
  form, 
  currentStep, 
  onNext, 
  onPrev, 
  children 
}: NapStepContainerProps) {
  return (
    <NapFormProvider form={form}>
      <div className="rounded-md bg-gradient-to-b from-slate-800/70 to-slate-900/90 p-5 border border-slate-700/50 shadow-inner">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -50, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="text-slate-200"
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </div>
    </NapFormProvider>
  );
}